import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { deleteFavouriteGameById, fetchFavouriteGames } from "../../../functions/favouriteGame";
import { addGameLabel, deleteGameLabel, fetchGameLabels, renameGameLabel, setGameLabels } from "../../../functions/favouriteGameLabel";
import { getLabelFilter, toggleLabel } from "../../../functions/labelUtils";
import PageLayout from "../../PageLayout";
import BottomAnchor from "../BottomAnchor";
import FavouriteGameDisplayer from "./favouritegame/view/FavouriteGameDisplayer";
import GameLabelArea from "./gamelabel/GameLabelArea";

function GamesAndLabels({ token, onError, onSearchProductClicked }) {
    const { t } = useTranslation('messages');

    const [games, setGames] = useState([]);
    const [labels, setLabels] = useState([]);
    const [checkedLabels, setCheckedLabels] = useState(new Map());

    useEffect(() => {
        fetchFavouriteGames(token, (data) => setGames(data.gamesWithLabels), onError, {});
        fetchGameLabels(token, (data) => setLabels(data.labels), onError);
    }, [token, onError]);

    return (
        <>
            <PageLayout
                heroPadding="py-4"
                hero={<h2 className="fw-bold mb-0">{t('private_area.games_box_title')}</h2>}
            >
                <Row className="g-4">
                    <Col xs={12} lg={3}>
                        <h6 className="fw-semibold text-muted text-uppercase small mb-3">
                            {t('private_area.games_tab.labels_title')}
                        </h6>
                        <GameLabelArea
                            gameLabels={labels}
                            checkedLabels={checkedLabels}
                            addNewLabel={(labelName) => onAddGameLabelClicked(token, labelName, setLabels, onError)}
                            deleteLabel={(labelId) => onDeleteLabelClicked(token, labelId, checkedLabels, setLabels, setGames, onError)}
                            renameLabel={(labelId, newLabelName) => onRenameLabelClicked(token, labelId, newLabelName, checkedLabels, setLabels, setGames, onError)}
                            checkLabel={(labelId) => onCheckLabelClicked(token, labelId, checkedLabels, setCheckedLabels, setGames, onError)}
                        />
                    </Col>
                    <Col xs={12} lg={9}>
                        <h6 className="fw-semibold text-muted text-uppercase small mb-3">
                            {t('private_area.games_tab.games_title')}
                        </h6>
                        <FavouriteGameDisplayer
                            gameLabels={labels}
                            favouriteGames={games}
                            associateLabels={(gameId, labelIds) => onAssociateLabelsClicked(token, gameId, labelIds, checkedLabels, setLabels, setGames, onError)}
                            deleteGame={(gameName) => onDeleteGameClicked(token, gameName, setGames, onError)}
                            onSearchProductClicked={onSearchProductClicked}
                        />
                    </Col>
                </Row>
            </PageLayout>

            <BottomAnchor favouriteGames={games} />
        </>
    );
}

function fetchData(token, setGames, setLabels, onError, checkedLabels) {
    fetchFavouriteGames(token, (data) => setGames(data.gamesWithLabels), onError, getLabelFilter(checkedLabels));
    fetchGameLabels(token, (data) => setLabels(data.labels), onError);
}

function onAddGameLabelClicked(token, labelName, setLabels, onError) {
    addGameLabel(token, (data) => setLabels(data.labels), onError, labelName);
}

function onDeleteLabelClicked(token, labelId, checkedLabels, setLabels, setGames, onError) {
    deleteGameLabel(token, () => fetchData(token, setGames, setLabels, onError, checkedLabels), onError, labelId);
}

function onRenameLabelClicked(token, labelId, newLabelName, checkedLabels, setLabels, setGames, onError) {
    renameGameLabel(token, () => fetchData(token, setGames, setLabels, onError, checkedLabels), onError, labelId, newLabelName);
}

function onCheckLabelClicked(token, labelId, checkedLabels, setCheckedLabels, setGames, onError) {
    const newCheckedLabels = toggleLabel(labelId, checkedLabels);
    fetchFavouriteGames(token, (data) => {
        setGames(data.gamesWithLabels);
        setCheckedLabels(newCheckedLabels);
    }, onError, getLabelFilter(newCheckedLabels));
}

function onAssociateLabelsClicked(token, gameId, labelIds, checkedLabels, setLabels, setGames, onError) {
    setGameLabels(token, () => fetchData(token, setGames, setLabels, onError, checkedLabels), onError, gameId, labelIds);
}

function onDeleteGameClicked(token, gameId, setGames, onError) {
    deleteFavouriteGameById(token, (data) => setGames(data.games), onError, gameId);
}

export default GamesAndLabels;
